import { type RefObject } from "react";
import { Card, CardContent } from "@mui/material";
import Grid from "@mui/material/Grid";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import { useTranslation } from "react-i18next";
import {
  IMAGE_ACCEPT,
  VIDEO_ACCEPT,
  MAX_IMAGE_SLOTS,
  TOTAL_EVIDENCE_SLOTS,
} from "@/constants";
import { FormLabel } from "./FormLabel";
import { FileUploadSlot } from "./FileUploadSlot";

interface EvidenceCardProps {
  images: (File | null)[];
  video: File | null;
  usedSlots: number;
  imageInputRefs: RefObject<HTMLInputElement | null>[];
  videoInputRef: RefObject<HTMLInputElement | null>;
  onImageSelect: (
    index: number,
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveImage: (index: number) => void;
  onVideoSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveVideo: () => void;
}

export function EvidenceCard({
  images,
  video,
  usedSlots,
  imageInputRefs,
  videoInputRef,
  onImageSelect,
  onRemoveImage,
  onVideoSelect,
  onRemoveVideo,
}: EvidenceCardProps) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent>
        <FormLabel
          label={`${t("form.evidence")} (${usedSlots}/${TOTAL_EVIDENCE_SLOTS} ${t("form.evidenceSlots")})`}
        />
        <Grid container spacing={1.5} sx={{ mt: 0.5 }}>
          {Array.from({ length: MAX_IMAGE_SLOTS }, (_, idx) => (
            <Grid size={6} key={`img-${idx}`}>
              <FileUploadSlot
                file={images[idx]}
                inputRef={imageInputRefs[idx]}
                accept={IMAGE_ACCEPT}
                icon={AddAPhotoIcon}
                label={t("form.screenshot")}
                onSelect={onImageSelect(idx)}
                onRemove={() => onRemoveImage(idx)}
              />
            </Grid>
          ))}
          <Grid size={6}>
            <FileUploadSlot
              file={video}
              inputRef={videoInputRef}
              accept={VIDEO_ACCEPT}
              icon={VideoCallIcon}
              label={t("form.video")}
              onSelect={onVideoSelect}
              onRemove={onRemoveVideo}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
